import Util from '../../../Common/Util';
/**
 * 환원예정 문자발송 모달 — 접수페이지(OrderList) '환원예정' 모드 전용.
 *
 * 진입 버튼은 '환원 문자발송' 하나뿐 — 발송/발송이력은 모달 헤더 탭(activeTab)으로 합쳐져
 * 있다(switchTab). 예전엔 outer 버튼이 둘(문자발송/문자내역)이라 발송이력이 별도 sub-modal
 * 오버레이였는데, 지금은 #tabPanelSend / #tabPanelHistory 두 패널을 같은 모달 안에서 토글한다.
 *
 *  발송탭 좌측: 환원예정 오더를 발주자(소유자) 단위로 묶은 대상자 리스트 (펼침형)
 *  발송탭 우측: 템플릿 기반 문자 작성 + 변수 치환({발주자명}{총건수}{총미결금액}{미결내역})
 *  발송탭 하단: 발송번호 선택 + 일괄발송(큐 적재)
 *  발송이력탭: g5_sms_send_logs(purpose='whan') 회차별 조회
 *  부가: 미리보기 / 샘플발송 / 진행률
 *
 * 데이터 소스
 * ───────────
 *  - 목록 : POST /adm/ajax/order/whan/list   (발주자별 그룹)
 *  - 발송 : POST /adm/ajax/order/whan/send   (SmsLog→bizgo 큐, matchListSend 패턴)
 *  - 이력 : POST /adm/ajax/order/whan/history
 *
 * 마크업은 #wsmRoot 컨테이너에 1회 주입되며, 인라인 onclick 은 window.WSM(=인스턴스)
 * 으로 브리지된다. 스타일은 public/css/a-whan-sms.css (모두 #wsmRoot 하위로 스코핑).
 *
 * OrderList(parent)가 openWhanSms() 에서 this.open() 을 호출한다.
 */

// 템플릿 본문은 하드코딩하지 않는다. 관리자 '알림 > 템플릿설정'에서 purpose='whan' 으로
// 작성한 내용을 g5_sms_template 에서 로드해 드롭다운을 채운다(matchList 와 동일 패턴).
// 모드별 사용 가능 변수 — AlimTemplateRenderer::whanKeys() 와 동일하게 유지.
const VARS_BALJOO = ['발주자명', '기준월', '환원예정일', '총건수', '총미결금액', '미결내역'];
const VARS_SOOJOO = ['수주자명', '발주자목록', '기준월', '환원예정일', '총건수', '총미수금액', '명세내역'];

export default class WhanSmsModal {
    constructor(parent) {
        this.parent        = parent;      // OrderList 인스턴스 (검색 파라미터 공유용)
        this.mode          = 'baljoo';    // 'baljoo'(발주자 그룹, 기본) | 'soojoo'(수주자 그룹)
        this.allOrderers   = [];          // 환원예정 전체 (서버 조회)
        this.orderers      = [];          // 선택된 대상 (미리보기/샘플/발송용)
        this.spSelected    = new Set();   // 선택된 발주자 키(o.mb)
        this.tgExpanded    = new Set();   // 펼침 상태
        this.currentPreviewIdx = 0;
        this.templates     = [];          // g5_sms_template purpose='whan' (서버 조회)
        this.sendHistory      = [];
        this.historyFilter    = ''; // 발송결과 필터: '' | ok | part | fail | pending (회차 결과 기준)
        this.historyMode      = ''; // 대상 필터: '' | baljoo | soojoo
        this.histBatchExpanded = new Set(); // 펼친 발송 회차(group_id)
        this.histPersonExpanded = new Set(); // 펼친 수신자(회차|mb)
        this.currentResendId  = null;       // 재발송 미리보기 대상 로그 id
        this.prevExpDateLabel  = '';
        this.expDateDefault    = '';
        this.built = false;
        this.activeTab = 'send'; // 'send' | 'history' — 모달 헤더의 탭. 두 화면이 같은 모달을 공유한다.

        // 발신번호 — OrderList 가 #page-data 에서 읽어 둔 배열 (OrderController::listPageData)
        const phones = parent.whanSenderPhones || [];
        this.senderNumbers = phones.map((p, i) => ({
            number: p,
            name: i === 0 ? '장비불러 대표번호' : '발신번호 ' + (i + 1),
            isDefault: i === 0,
        }));
        if (!this.senderNumbers.length) this.senderNumbers = [{ number: '', name: '발신번호 미설정', isDefault: true }];
        this.selectedSender    = this.senderNumbers[0];
        this.tempSelectedSender = null;
    }

    // ==================== 진입점 ====================
    open() {
        this.ensureBuilt();
        // 이전에 발송이력 탭에 있다가 닫힌 경우를 대비해 항상 발송 탭으로 되돌리고 연다 —
        // closeSendModal() 은 감추기만 하고 탭 상태는 그대로 두기 때문에, 안 하면 '환원 문자발송'
        // 버튼을 눌렀는데 발송이력 화면이 뜨는 걸로 보인다.
        this.switchTab('send');
        this.fetchList();
    }

    /** 발주자/수주자 모드 전환 — 같은 검색조건으로 목록 재조회 (서버 그룹핑이 달라짐). */
    setMode(mode) {
        if (mode !== 'baljoo' && mode !== 'soojoo') return;
        if (this.mode === mode) return;
        this.mode = mode;
        // 검색바 placeholder 도 모드에 맞춰 변경
        $('#spSearch').attr('placeholder', mode === 'soojoo' ? '수주자명/연락처' : '발주자명/연락처').val('');
        $('.wsm-mode-btn').removeClass('active').filter(`[data-mode="${mode}"]`).addClass('active');
        this.fetchList();
    }

    /** 환원예정 대상자 목록 조회 → 전체선택 → 렌더 → 모달 표시. */
    fetchList() {
        const self = this;
        // 접수목록(getList)과 동일한 검색 파라미터로 조회 → 목록 완전 일치
        const params = this.parent && this.parent.currentSearchParams
            ? this.parent.currentSearchParams()
            : { d1: $('#d1').val(), d2: $('#d2').val(), x: $('#x').val(), w: '1' };
        params.mode = this.mode;  // baljoo|soojoo 그룹핑 모드 전달
        this.searchParams = params; // 발송 직전 재검증이 목록과 동일 필터를 쓰도록 보관
        $.ajax({
            url: '/adm/ajax/order/whan/list',
            type: 'post',
            data: params,
            success(res) {
                if (!res || !res.ok) { self.toast('대상자 목록을 불러오지 못했습니다.', 'danger'); return; }
                self.allOrderers = res.list || [];
                self.expDateDefault = res.expDate || '';
                self.templates = res.templates || [];

                self.spSelected.clear();
                self.tgExpanded.clear();
               // 이미 발송이력이 있는 발주자(o.sent)는 자동선택에서 제외
                self.allOrderers.forEach(o => { if (!o.sent) self.spSelected.add(o.mb); });
                self.currentPreviewIdx = 0;

                if (self.expDateDefault) $('#expDate').val(self.expDateDefault);
                self.prevExpDateLabel  = self.getExpDateLabel();
                self.renderPanelSub();
                self.renderTemplateOptions();
                self.renderTargetList();
                self.applyTemplate();
                self.updateMeta();

                $('#bgOverlay').show();
                $('#modalWrap').css('display', 'flex');
            },
            error() { self.toast('서버 오류로 목록을 불러오지 못했습니다.', 'danger'); },
        });
    }

    closeSendModal() {
        $('#bgOverlay').hide();
        $('#modalWrap').hide();
    }

    // ==================== 헬퍼 ====================
    getByte(s) {
        let b = 0;
        for (let i = 0; i < s.length; i++) b += s.charCodeAt(i) > 127 ? 2 : 1;
        return b;
    }
    /** 기준월 — 발주자별 오더 작업월(서버 baseDate). 환원예정일과 무관, 수신자별로 다름. */
    getBaseMonthLabel(o) {
        if (!o || !o.baseDate) return '';
        const dt = new Date(o.baseDate);
        return `${String(dt.getFullYear()).slice(2)}년 ${dt.getMonth() + 1}월`;
    }
    getExpDateLabel() {
        const d = $('#expDate').val();
        if (!d) return '';
        const dt = new Date(d);
        return `${String(dt.getFullYear()).slice(2)}년 ${dt.getMonth() + 1}월 ${dt.getDate()}일(말일)`;
    }
    renderPanelSub() {
        const d = $('#expDate').val();
        if (!d) { $('#wsmExpLabel').text('-'); $('#wsmDday').text('-'); return; }
        $('#wsmExpLabel').text(d);
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const diff = Math.round((new Date(d) - today) / 86400000);
        $('#wsmDday').text(diff >= 0 ? 'D-' + diff : 'D+' + Math.abs(diff));
    }

    // ==================== 대상자 리스트 ====================
    getFilteredTargets() {
        const biz = $('#spBizFilter').val() || '';
        const search = ($('#spSearch').val() || '').trim().toLowerCase();
        return this.allOrderers.filter(o => {
            if (biz && !o.orders.some(r => r.biz === biz)) return false;
            if (search && !(o.name.toLowerCase().includes(search) || (o.tel || '').includes(search))) return false;
            return true;
        });
    }

    /** 업종 필터 변경 시 — 기존 선택을 비우고 해당 업종의 '미발송' 대상자만 선택한다. */
    onBizFilterChange() {
        this.spSelected.clear();
        this.getFilteredTargets().forEach(o => { if (!o.sent) this.spSelected.add(o.mb); });
        this.renderTargetList();
    }

    renderTargetList() {
        const self = this;
        const list = this.getFilteredTargets();
        const wrap = document.getElementById('targetList');
        if (!wrap) return;
        if (list.length === 0) {
            wrap.innerHTML = `<div style="padding:50px;text-align:center;color:#909090;font-size:14px">조건에 맞는 대상자가 없습니다.</div>`;
            this.updateStats();
            return;
        }
        wrap.innerHTML = list.map((o, i) => {
            const total = o.orders.reduce((s, r) => s + r.amt, 0);
            const isChecked  = self.spSelected.has(o.mb);
            const isExpanded = self.tgExpanded.has(o.mb);
            const hazardHtml = o.hazard
                ? `<span class="hazard-card ${o.hazard}" title="${o.hazard === 'yellow' ? '🟡 옐로우카드' : '🔴 레드카드'} — ${Util.escapeHtml(o.hazardReason)}"></span>`
                : '';
            // 현재 모드(발주/수주)와 일치하는 발송이력만 '발송됨'으로 본다.
            // (발주자로 보낸 사람을 수주자 목록에서 발송됨으로 표시하면 o.sent(모드별)·전체선택과 어긋남)
            const lastSend = self.sendHistory.find(h => h.mb === o.mb && h.mode === self.mode);
            let sendBadge = '';
            if (lastSend) {
                const sign = lastSend.status === 'success' ? '✓' : lastSend.status === 'fail' ? '✗' : '⏳';
                sendBadge = `<span class="send-badge ${lastSend.status}" title="${lastSend.sentAt}">${sign} 발송</span>`;
            } else if (o.sent) {
                // 서버에서 내려준 발송이력 보유 플래그 — 자동선택 제외 대상임을 표시
                sendBadge = `<span class="send-badge success" title="이전 발송이력 있음 (자동선택 제외)">✓ 발송됨</span>`;
            }
            const isSoojooMode = self.mode === 'soojoo';
            const detailRows = o.orders.map(r => `
                <tr>
                    <td class="d-onum">${r.onum}</td>
                    <td class="d-biz-cell"><span class="d-biz">${self.escapeHtml(r.biz)}</span></td>
                    <td class="d-date">${r.wdate}</td>
                    <td class="d-site">${self.escapeHtml(r.site)}</td>
                    <td class="d-amt">${r.amt.toLocaleString()}</td>
                    <td class="d-soo">${self.escapeHtml(isSoojooMode ? (r.balName || '') : (r.sooName || ''))}</td>
                    <td class="d-sootel">${self.escapeHtml(Util.phoneNumber(isSoojooMode ? (r.balTel || '') : (r.sooTel || '')))}</td>
                </tr>`).join('');
            return `
                <div class="tg-card ${isChecked ? 'checked' : ''} ${isExpanded ? 'expanded' : ''}" data-mb="${o.mb}">
                    <div class="tg-head" onclick="WSM.tgToggleExpand('${o.mb}', event)">
                        <div class="tg-cb" onclick="WSM.tgToggleCheck('${o.mb}', event)"></div>
                        <div class="tg-seq">${i + 1}</div>
                        <div class="tg-name"><span class="nm">${self.escapeHtml(o.name)}</span>${hazardHtml}${sendBadge}</div>
                        <div class="tg-tel">${self.escapeHtml(Util.phoneNumber(o.tel || ''))}</div>
                        <div class="tg-count">${o.orders.length}건</div>
                        <div class="tg-amount">${total.toLocaleString()}원</div>
                        <div class="tg-chevron">▼</div>
                        <div class="tg-divider-v"></div>
                        <button class="tg-del" onclick="WSM.deleteTarget(event, '${o.mb}')" title="목록에서 제외">✕</button>
                    </div>
                    <div class="tg-detail">
                        <table>
                            <thead><tr>
                                <th style="width:72px">오더번호</th>
                                <th style="width:62px">업종</th>
                                <th style="width:52px">작업일</th>
                                <th style="padding-left:18px">현장주소</th>
                                <th style="width:80px">금액</th>
                                <th style="width:62px">${isSoojooMode ? '발주자' : '수주자'}</th>
                                <th style="width:112px">연락처</th>
                            </tr></thead>
                            <tbody>${detailRows}</tbody>
                        </table>
                    </div>
                </div>`;
        }).join('');
        this.updateStats();
    }

    tgToggleCheck(mb, e) {
        e.stopPropagation();
        if (this.spSelected.has(mb)) this.spSelected.delete(mb);
        else this.spSelected.add(mb);
        this.renderTargetList();
    }
    tgToggleExpand(mb, e) {
        if (e && e.target.closest('.tg-cb')) return;
        if (e && e.target.closest('.tg-del')) return;
        if (this.tgExpanded.has(mb)) this.tgExpanded.delete(mb);
        else this.tgExpanded.add(mb);
        this.renderTargetList();
    }
    spToggleAll() {
        // 전체선택: 미발송 대상만 선택. 전체해제 시에는 발송됨 포함 모두 해제.
        const targets    = this.getFilteredTargets();
        const selectable = targets.filter(o => !o.sent);
        const allChecked = selectable.length > 0 && selectable.every(o => this.spSelected.has(o.mb));
        if (allChecked) targets.forEach(o => this.spSelected.delete(o.mb));
        else selectable.forEach(o => this.spSelected.add(o.mb));
        this.renderTargetList();
    }
    spToggleSent() {
        // 발송됨 포함: 발송됨(o.sent) 대상만 전체선택/전체해제
        const sentTargets = this.getFilteredTargets().filter(o => o.sent);
        const allChecked  = sentTargets.length > 0 && sentTargets.every(o => this.spSelected.has(o.mb));
        if (allChecked) sentTargets.forEach(o => this.spSelected.delete(o.mb));
        else sentTargets.forEach(o => this.spSelected.add(o.mb));
        this.renderTargetList();
    }

    updateStats() {
        const selList   = this.allOrderers.filter(o => this.spSelected.has(o.mb));
        const selOrders = selList.reduce((s, o) => s + o.orders.length, 0);
        const selAmt    = selList.reduce((s, o) => s + o.orders.reduce((ss, r) => ss + r.amt, 0), 0);
        $('#statTargets').text(selList.length);
        $('#statOrders').text(selOrders);
        $('#statAmount').text(selAmt.toLocaleString());

        // 헤더 체크박스 상태도 '발송됨' 제외한 미발송 대상 기준
        const selectable = this.getFilteredTargets().filter(o => !o.sent);
        const $checkAll = $('#spCheckAll');
        $checkAll.removeClass('checked indeterminate');
        const allChecked  = selectable.length > 0 && selectable.every(o => this.spSelected.has(o.mb));
        const someChecked = selectable.some(o => this.spSelected.has(o.mb));
        if (allChecked) $checkAll.addClass('checked');
        else if (someChecked) $checkAll.addClass('indeterminate');

        // '발송됨 포함' 버튼 상태 — 발송됨(o.sent) 대상 기준. 대상 없으면 비활성(흐리게)만, 숨기진 않음.
        const sentTargets = this.getFilteredTargets().filter(o => o.sent);
        const $incSent = $('#spIncludeSent').removeClass('checked indeterminate');
        $incSent.toggleClass('is-disabled', sentTargets.length === 0);
        const sentAll  = sentTargets.length > 0 && sentTargets.every(o => this.spSelected.has(o.mb));
        const sentSome = sentTargets.some(o => this.spSelected.has(o.mb));
        if (sentAll) $incSent.addClass('checked');
        else if (sentSome) $incSent.addClass('indeterminate');

        const hasBody = !!$('#msgBody').val().trim();
        $('#sendBtn').prop('disabled', selList.length === 0 || !hasBody);
        $('#footerInfo').html(selList.length === 0
            ? '발송할 대상자를 선택하세요'
            : `<strong>${selList.length}</strong>명 / <strong>${selOrders}</strong>건 · 총 <strong>${selAmt.toLocaleString()}</strong>원 발송 예정`);

        // 미리보기/샘플/발송용 동기화 (깊은 복제)
        this.orderers = selList.map(o => ({ ...o, orders: o.orders.map(r => ({ ...r })) }));
    }

    deleteTarget(e, mb) {
        e.stopPropagation();
        const o = this.allOrderers.find(x => x.mb === mb);
        if (!o) return;
        // 회원명이 든 문장 — swalert 는 '<' 가 있으면 HTML 로 그리므로 텍스트 슬롯(Dialog)으로 연다
        $j.Ui.Dialog.open({
            title:   `${o.name}님을 발송 대상 목록에서 제외하시겠습니까?`,
            confirm: '제외',
            cancel:  '취소',
            onConfirm: () => {
                this.allOrderers = this.allOrderers.filter(x => x.mb !== mb);
                this.spSelected.delete(mb);
                this.tgExpanded.delete(mb);
                this.renderTargetList();
                this.toast(`${o.name}님을 목록에서 제외했습니다.`, 'success');
            },
        });
    }

    // ==================== 메시지 작성 ====================
    /** g5_sms_template(purpose='whan') 로 드롭다운 채움. + 직접작성 옵션. */
    // 현재 모드(detail_purpose)에 맞는 템플릿만 노출. detail 이 비어있는 레거시 템플릿은
    // 발주자(baljoo)용으로 간주 — 기존 데이터 호환.
    templatesForMode() {
        const m = this.mode;
        return this.templates.filter(t => {
            const d = (t.detail || '').trim();
            if (m === 'baljoo') return d === '' || d === 'baljoo';
            return d === 'soojoo';
        });
    }
    renderTemplateOptions() {
        this._tplFiltered = this.templatesForMode();
        const opts = this._tplFiltered.map((t, i) => `<option value="${i}">${this.escapeHtml(t.name || ('템플릿 ' + (i + 1)))}</option>`);
        opts.push('<option value="custom">[직접작성]</option>');
        $('#templateSelect').html(opts.join(''));
        // 등록된 템플릿이 있으면 첫 템플릿, 없으면 직접작성
        $('#templateSelect').val(this._tplFiltered.length ? '0' : 'custom');
    }
    applyTemplate() {
        const v = $('#templateSelect').val();
        let raw = '';
        if (v !== 'custom' && v !== '' && v != null) {
            const t = (this._tplFiltered || this.templates)[parseInt(v, 10)];
            raw = t ? (t.body || '') : '';
        }
        // {환원예정일}만 전역 치환. {기준월}은 발주자별로 다르므로 본문엔 토큰으로 남겨
        // 미리보기/발송 시점에 수신자별로 치환한다({발주자명}과 동일 취급).
        raw = raw.replace(/\{환원예정일\}/g, this.getExpDateLabel());
        $('#msgBody').val(raw);
        this.updateMeta();
    }
    resetTemplate() {
        Util.swalert('템플릿을 초기값으로 되돌릴까요?\n작성 중인 내용이 사라집니다.', () => {
            this.applyTemplate();
            this.toast('템플릿이 초기화되었습니다.', 'success');
        }, ['초기화', '취소']);
    }
    onExpDateChange() {
        const newDate = this.getExpDateLabel();
        const ta = document.getElementById('msgBody');
        if (this.prevExpDateLabel && this.prevExpDateLabel !== newDate && ta.value.includes(this.prevExpDateLabel)) {
            ta.value = ta.value.split(this.prevExpDateLabel).join(newDate);
            this.toast(`📅 환원예정일이 갱신되었습니다 (${newDate})`, 'success');
            this.updateMeta();
        }
        this.prevExpDateLabel = newDate;
        this.renderPanelSub();
    }
    updateMeta() {
        const v = $('#msgBody').val();
        const b = this.getByte(v);
        $('#byteCount').text(b.toLocaleString());
        $('#lineCount').text(v.split('\n').length);
        let type = 'SMS', cls = 'sms';
        if (b > 2000) { type = 'MMS'; cls = 'mms'; }
        else if (b > 90) { type = 'LMS'; cls = 'lms'; }
        $('#msgType').text(type).attr('class', 'type-tag ' + cls);
        this.validateVars();
        this.updateStats();
        this.updateHighlight();
    }
    /** textarea 뒤 하이라이트 레이어를 본문과 동기화 — 날짜 문자열만 초록으로 렌더. */
    updateHighlight() {
        const ta = document.getElementById('msgBody');
        const hl = document.getElementById('msgHighlight');
        if (!ta || !hl) return;
        hl.innerHTML = this.buildHighlight(ta.value);
        hl.scrollTop = ta.scrollTop;
        hl.scrollLeft = ta.scrollLeft;
    }
    syncHighlightScroll() {
        const ta = document.getElementById('msgBody');
        const hl = document.getElementById('msgHighlight');
        if (!ta || !hl) return;
        hl.scrollTop = ta.scrollTop;
        hl.scrollLeft = ta.scrollLeft;
    }
    /** 본문 원문에서 환원예정일(전역 치환된 literal)만 초록 span 으로 감싼다.
     *  ({기준월}은 발주자별 토큰으로 본문에 그대로 남으므로 여기선 강조하지 않는다.) */
    buildHighlight(text) {
        const date = this.escapeHtml(this.getExpDateLabel());   // 예: 26년 5월 31일(말일)
        let out = this.escapeHtml(text);
        if (date) out = out.split(date).join(`<span class="date-hl">${date}</span>`);
        return out + '\n';   // textarea 의 마지막 줄(개행)과 높이 정렬
    }
    /** 현재 모드에서 사용 가능한 변수 키 배열 */
    validVars() { return this.mode === 'soojoo' ? VARS_SOOJOO : VARS_BALJOO; }

    validateVars() {
        const text = $('#msgBody').val();
        const $warn = $('#varWarning');
        if (!text.trim()) {
            $warn.attr('class', 'var-warning empty').html('문자 내용을 입력하세요.');
            return { valid: false, reason: 'empty' };
        }
        const validVars = this.validVars();
        const matches = [...text.matchAll(/\{([^}]*)\}/g)].map(m => m[1]);
        const invalid = [...new Set(matches.filter(m => !validVars.includes(m)))];
        const empty = matches.includes('');
        if (invalid.length > 0 || empty) {
            const parts = [];
            if (invalid.length > 0) parts.push(`<strong>⚠ 알 수 없는 변수가 있습니다:</strong> ${invalid.map(v => `<code>{${v}}</code>`).join(' ')}`);
            if (empty) parts.push(`<strong>⚠ 빈 변수 <code>{}</code>가 있습니다.</strong>`);
            parts.push(`사용 가능한 변수: ${validVars.map(v => `<code>{${v}}</code>`).join(' ')}`);
            $warn.attr('class', 'var-warning show').html(parts.join('<br>'));
            return { valid: false, reason: 'invalid', invalid };
        }
        // 정상일 때는 별도 안내문구 없이 경고박스를 숨긴다.
        $warn.attr('class', 'var-warning').html('');
        return { valid: true };
    }

    // ==================== 변수 치환 ====================
    // 발주자 모드: 행에 '수주자' 정보를 보여줌 (누구에게 줄 돈인지)
    // 수주자 모드: 행에 '발주자' 정보를 보여줌 (누구에게 받을 돈인지)
    buildDetailLines(o) {
        const soojoo = this.mode === 'soojoo';
        return o.orders.map(r => {
            const other = soojoo
                ? `${r.balName || ''} / ${Util.phoneNumber(r.balTel || '')}`
                : `${r.sooName || ''} / ${Util.phoneNumber(r.sooTel || '')}`;
            return `* ${r.wdate} / ${r.site} / ${r.amt.toLocaleString()}원 / ${other}`;
        }).join('\n');
    }
    /** 수주자 모드 — 오더에서 발주자 이름 중복제거하여 콤마 연결 */
    buildBaljooList(o) {
        const seen = new Set();
        const names = [];
        o.orders.forEach(r => {
            const n = (r.balName || '').trim();
            if (n && !seen.has(n)) { seen.add(n); names.push(n); }
        });
        return names.join(', ');
    }
    renderPlain(o) {
        const v = $('#msgBody').val();
        if (!v) return '문자 내용을 입력하세요.';
        const totalAmt = o.orders.reduce((s, r) => s + r.amt, 0);
        let out = v
            .replace(/\{기준월\}/g, this.getBaseMonthLabel(o))
            .replace(/\{환원예정일\}/g, this.getExpDateLabel())
            .replace(/\{총건수\}/g, o.orders.length);
        if (this.mode === 'soojoo') {
            out = out
                .replace(/\{수주자명\}/g, o.name)
                .replace(/\{발주자목록\}/g, this.buildBaljooList(o))
                .replace(/\{총미수금액\}/g, totalAmt.toLocaleString())
                .replace(/\{명세내역\}/g, this.buildDetailLines(o));
        } else {
            out = out
                .replace(/\{발주자명\}/g, o.name)
                .replace(/\{총미결금액\}/g, totalAmt.toLocaleString())
                .replace(/\{미결내역\}/g, this.buildDetailLines(o));
        }
        return out;
    }
    renderHTMLMsg(o) {
        const v = $('#msgBody').val();
        if (!v) return '문자 내용을 입력하세요.';
        const totalAmt = o.orders.reduce((s, r) => s + r.amt, 0);
        const detail = this.buildDetailLines(o);
        const detailHtml = `<span class="detail-lines">${detail.split('\n').map(line => `<span class="detail-line">${this.escapeHtml(line)}</span>`).join('')}</span>`;
        const mark = (s) => `<span class="var-mark">${this.escapeHtml(String(s))}</span>`;
        let html = this.escapeHtml(v)
            .replace(/\{기준월\}/g, this.getBaseMonthLabel(o))
            .replace(/\{환원예정일\}/g, this.getExpDateLabel())
            .replace(/\{총건수\}/g, mark(o.orders.length));
        if (this.mode === 'soojoo') {
            html = html
                .replace(/\{수주자명\}/g, mark(o.name))
                .replace(/\{발주자목록\}/g, mark(this.buildBaljooList(o)))
                .replace(/\{총미수금액\}/g, mark(totalAmt.toLocaleString()))
                .replace(/\{명세내역\}/g, detailHtml);
        } else {
            html = html
                .replace(/\{발주자명\}/g, mark(o.name))
                .replace(/\{총미결금액\}/g, mark(totalAmt.toLocaleString()))
                .replace(/\{미결내역\}/g, detailHtml);
        }
        // 치환된 기준월/환원예정일을 초록색으로 강조 (상단 날짜 입력과 동일 색상)
        return this.highlightDates(html, o);
    }
    /** 본문 HTML 안의 환원예정일·기준월 문자열을 초록 마크로 감싼다. */
    highlightDates(html, o) {
        const date  = this.escapeHtml(this.getExpDateLabel());   // 예: 26년 5월 31일(말일)
        const month = this.escapeHtml(this.getBaseMonthLabel(o)); // 예: 26년 3월 — date 의 부분문자열이므로 먼저 처리
        const DATE_PH = '\u0001', MONTH_PH = '\u0002';
        let out = html;
        if (date)  out = out.split(date).join(DATE_PH);
        if (month) out = out.split(month).join(MONTH_PH);
        return out
            .split(DATE_PH).join(`<span class="var-mark-date">${date}</span>`)
            .split(MONTH_PH).join(`<span class="var-mark-date">${month}</span>`);
    }

    // ==================== 미리보기 ====================
    openPreviewModal() { $('#previewModal').addClass('show'); this.refreshPreviewModal(); }
    closePreviewModal() { $('#previewModal').removeClass('show'); }
    refreshPreviewModal() {
        const total = this.orderers.length;
        $('#previewTotal').text(total);
        $('#previewModalCount').text(total + '건');
        if (total === 0) { $('#previewBubble').text('대상자가 없습니다.'); return; }
        if (this.currentPreviewIdx >= total) this.currentPreviewIdx = 0;
        const o = this.orderers[this.currentPreviewIdx];
        $('#previewIdx').text(this.currentPreviewIdx + 1);
        $('#previewTarget').text(`${o.name} · ${Util.phoneNumber(o.tel)}`);
        $('#previewBubble').html(this.renderHTMLMsg(o));
        $('#prevBtn,#nextBtn').prop('disabled', total <= 1);
    }
    prevPreview() {
        const total = this.orderers.length;
        if (total <= 1) return;
        this.currentPreviewIdx = (this.currentPreviewIdx - 1 + total) % total;
        this.refreshPreviewModal();
    }
    nextPreview() {
        const total = this.orderers.length;
        if (total <= 1) return;
        this.currentPreviewIdx = (this.currentPreviewIdx + 1) % total;
        this.refreshPreviewModal();
    }

    // ==================== 샘플 발송 ====================
    /** 샘플 치환 기준 대상 — 현재 미리보기 대상, 없으면 첫 대상자. */
    sampleBasisTarget() {
        if (this.orderers[this.currentPreviewIdx]) return this.orderers[this.currentPreviewIdx];
        return this.orderers[0] || null;
    }
    openSampleModal() {
        $('#sampleTel').val('');
        $('#sampleModal').addClass('show');
        setTimeout(() => $('#sampleTel').trigger('focus'), 50);
    }
    closeSampleModal() { $('#sampleModal').removeClass('show'); }
    sendSample() {
        const self = this;
        const tel = $('#sampleTel').val().trim();
        if (!tel) { this.toast('받는 번호를 입력하세요.', 'danger'); return; }
        const o = this.sampleBasisTarget();
        if (!o) { this.toast('치환할 대상자가 없습니다.', 'danger'); return; }
        const msg = this.renderPlain(o);
        $.ajax({
            url: '/adm/ajax/order/whan/send',
            type: 'post',
            // is_sample=1 → 서버가 purpose='test' 로 발송 → 발송이력(purpose='whan')에 저장 안 됨
            data: { from_phone: this.selectedSender.number, is_sample: 1, targets: [{ mb_no: 0, phone: tel, message: msg }] },
            success(res) {
                if (res && res.ok) { self.closeSampleModal(); self.toast(`✅ 샘플 문자가 ${tel}로 발송 요청되었습니다.`, 'success'); }
                else self.toast((res && res.message) || '샘플 발송 실패', 'danger');
            },
            error() { self.toast('샘플 발송 중 오류가 발생했습니다.', 'danger'); },
        });
    }

    // ==================== 발송 이력 (회차별 그룹) ====================
    // 발송결과 필터 — 세금계산서 발송내역과 동일한 pill 버튼(전체/성공/일부성공/실패/대기).
    // 회차(배치)의 집계 결과 기준으로 거른다.
    setHistoryFilter(f, btn) {
        this.historyFilter = f || '';
        $('#wsmRoot #histStatusPills .hist-pill').removeClass('active');
        if (btn) btn.classList.add('active');
        this.renderHistory();
    }
    setHistoryMode(m, btn) {
        this.historyMode = m || '';
        $('#wsmRoot #histModePills .hist-pill').removeClass('active');
        if (btn) btn.classList.add('active');
        this.renderHistory();
    }
    // 회차의 대상 모드 — soojoo 만 명시, 그 외(baljoo·레거시)는 baljoo. (템플릿 표기와 동일 기준)
    batchMode(items) { return (items[0] || {}).mode === 'soojoo' ? 'soojoo' : 'baljoo'; }

    /**
     * 헤더 탭 전환 — #tabPanelSend / #tabPanelHistory 토글. 발송이력 탭은 항상
     * openHistoryModal() 을 거쳐서 들어온다(매번 재조회 + 필터초기화), 이 메서드는
     * 순수 화면전환만 한다.
     * @param {'send'|'history'} tab
     */
    switchTab(tab) {
        this.activeTab = tab;
        $('#wsmRoot .wsm-tab').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
        // .toggle(bool) 대신 명시적으로 display 를 지정한다 — #tabPanelHistory 는 마크업에서부터
        // 인라인 display:none 이라 jQuery 가 "원래 값"을 모르고, 되돌릴 때 flex 대신 기본값(block)을
        // 넣어버릴 수 있다.
        $('#tabPanelSend').css('display', tab === 'send' ? 'flex' : 'none');
        $('#tabPanelHistory').css('display', tab === 'history' ? 'flex' : 'none');
    }

    openHistoryModal() {
        const self = this;
        this.switchTab('history');
        this.histBatchExpanded.clear();
        this.histPersonExpanded.clear();
        // 발송결과 필터 초기화 → '전체'
        this.historyFilter = '';
        $('#wsmRoot #histStatusPills .hist-pill').removeClass('active');
        $('#wsmRoot #histStatusPills .hist-pill[data-st=""]').addClass('active');
        // 대상(발주/수주) 필터 초기화 → '전체'
        this.historyMode = '';
        $('#wsmRoot #histModePills .hist-pill').removeClass('active');
        $('#wsmRoot #histModePills .hist-pill[data-hm=""]').addClass('active');
        $.ajax({
            url: '/adm/ajax/order/whan/history', type: 'post', data: { keyword: '' },
            success(res) {
                self.sendHistory = (res && res.list) || [];
                self.setHistPeriod('tm', document.querySelector('#wsmRoot .hist-pill[data-hp="tm"]')); // 기본: 이달
                self.renderHistory();
            },
            error() { self.toast('발송 이력을 불러오지 못했습니다.', 'danger'); },
        });
    }

    /** 발송일시 기간 프리셋 (이달/전달). 'c'(날짜지정)는 사용자가 직접 입력. */
    setHistPeriod(p, btn) {
        $('#wsmRoot .hist-pill[data-hp]').removeClass('active');
        if (btn) btn.classList.add('active');
        const ref = new Date();
        const fromEl = document.getElementById('histDateFrom');
        const toEl   = document.getElementById('histDateTo');
        if (p === 'tm') {
            const y = ref.getFullYear(), m = ref.getMonth();
            fromEl.value = `${y}-${Util.pad(m + 1, 2)}-01`;
            toEl.value   = `${y}-${Util.pad(m + 1, 2)}-${Util.pad(new Date(y, m + 1, 0).getDate(), 2)}`;
        } else if (p === 'lm') {
            const d = new Date(ref.getFullYear(), ref.getMonth() - 1, 1);
            fromEl.value = `${d.getFullYear()}-${Util.pad(d.getMonth() + 1, 2)}-01`;
            toEl.value   = `${d.getFullYear()}-${Util.pad(d.getMonth() + 1, 2)}-${Util.pad(new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate(), 2)}`;
        }
        this.renderHistory();
    }
    onHistDateInput() {
        $('#wsmRoot .hist-pill[data-hp]').removeClass('active');
        $('#wsmRoot .hist-pill[data-hp="c"]').addClass('active');
        this.renderHistory();
    }
    // 회차 펼침/접힘 — 전체 재렌더 없이 detail 행만 in-place 로 넣고 뺀다. (스크롤 점프 원천 차단)
    toggleHistBatch(batchId, e) {
        if (e) e.stopPropagation();
        const tr = document.querySelector(`#historyList [data-bid="${CSS.escape(batchId)}"]`);
        const willExpand = !this.histBatchExpanded.has(batchId);
        if (willExpand) this.histBatchExpanded.add(batchId);
        else this.histBatchExpanded.delete(batchId);
        if (!tr) { this.renderHistory(); return; }

        const btn  = tr.querySelector('.hist-expand-btn');
        const next = tr.nextElementSibling;
        if (willExpand) {
            tr.classList.add('expanded');
            if (btn) btn.textContent = '접기';
            const batch = this._histBatches && this._histBatches.get(batchId);
            if (batch && !(next && next.classList.contains('hist-detail-row'))) {
                const blocks = batch.filteredItems.map(h => this.renderHistPerson(batch, h)).join('');
                tr.insertAdjacentHTML('afterend', `<tr class="hist-detail-row"><td colspan="8" style="padding:0"><div class="hist-detail-box">${blocks}</div></td></tr>`);
            }
        } else {
            tr.classList.remove('expanded');
            if (btn) btn.textContent = '펼치기';
            if (next && next.classList.contains('hist-detail-row')) next.remove();
        }
    }
    // 수신자 펼침/접힘 — .ld-sub 표시 토글만, 역시 재렌더 없이 in-place.
    toggleHistPerson(key, e) {
        if (e) e.stopPropagation();
        const willExpand = !this.histPersonExpanded.has(key);
        if (willExpand) this.histPersonExpanded.add(key);
        else this.histPersonExpanded.delete(key);
        const row = document.querySelector(`#historyList [data-pkey="${CSS.escape(key)}"]`);
        if (!row) { this.renderHistory(); return; }
        const chevron = row.querySelector('.ld-chevron');
        const sub     = row.nextElementSibling; // .ld-sub
        if (chevron) chevron.classList.toggle('open', willExpand);
        if (sub && sub.classList.contains('ld-sub')) sub.classList.toggle('show', willExpand);
    }

    /** 회차(배치) 집계 결과 코드 — 세금계산서 발송내역과 동일 기준.
     *  ok=전부성공, fail=전부실패, pending=전부대기, part=일부성공(혼재). */
    batchResult(items) {
        const bs = items.reduce((s, h) => { s[h.status]++; return s; }, { success: 0, fail: 0, pending: 0 });
        if (bs.pending > 0)   return 'pending'; // 대기 우선 — 대기 섞이면 대기
        if (bs.fail === 0)    return 'ok';      // 전부 성공
        if (bs.success === 0) return 'fail';    // 전부 실패
        return 'part';                          // 성공/실패 혼재
    }
    renderHistory() {
        const self = this;
        const search = ($('#histSearch').val() || '').trim().toLowerCase();

        // 회차(group_id)별 그룹핑
        const batchMap = new Map();
        this.sendHistory.forEach(h => {
            if (!batchMap.has(h.groupId)) batchMap.set(h.groupId, { batchId: h.groupId, sentAt: h.sentAt, sentBy: h.sentBy, items: [] });
            batchMap.get(h.groupId).items.push(h);
        });
        let batches = [...batchMap.values()].sort((a, b) => b.sentAt.localeCompare(a.sentAt));

        const dFrom = $('#histDateFrom').val();
        const dTo   = $('#histDateTo').val();
        const rendered = batches.filter(b => {
            const d = b.sentAt.slice(0, 10);
            if (dFrom && d < dFrom) return false;
            if (dTo && d > dTo) return false;
            // 발송결과 필터 — 회차 집계 결과 기준
            if (this.historyFilter && self.batchResult(b.items) !== this.historyFilter) return false;
            // 대상(발주/수주) 필터
            if (this.historyMode && self.batchMode(b.items) !== this.historyMode) return false;
            return true;
        }).map(b => {
            let items = b.items;
            if (search) items = items.filter(h => h.name.toLowerCase().includes(search) || (h.tel || '').includes(search));
            return { ...b, filteredItems: items };
        }).filter(b => b.filteredItems.length > 0);

        // in-place 펼침(toggleHistBatch)이 참조할 회차 데이터 보관
        this._histBatches = new Map(rendered.map(b => [b.batchId, b]));

        const tbody = document.getElementById('historyList');
        if (rendered.length === 0) {
            tbody.innerHTML = `<tr><td colspan="8" class="hist-empty-td">📭 조건에 맞는 발송 이력이 없습니다.</td></tr>`;
            return;
        }
        tbody.innerHTML = rendered.map(b => self.renderHistBatch(b)).join('');
    }
    renderHistBatch(batch) {
        const self = this;
        let totalAmt = 0, totalOrders = 0;
        batch.items.forEach(h => { totalAmt += (h.amount || 0); totalOrders += (h.orderCount || 0); });
        const code = this.batchResult(batch.items);
        const result = { ok: '성공', fail: '실패', pending: '대기', part: '일부성공' }[code];
        const resCls = { ok: 'st-ok', fail: 'st-fail', pending: 'st-pending', part: 'st-part' }[code];
        const isExpanded = this.histBatchExpanded.has(batch.batchId);

        let html = `
            <tr class="hist-batch-row ${isExpanded ? 'expanded' : ''}" data-bid="${batch.batchId}">
                <td><button class="hist-expand-btn" onclick="WSM.toggleHistBatch('${batch.batchId}', event)">${isExpanded ? '접기' : '펼치기'}</button></td>
                <td class="hb-when">${this.escapeHtml(batch.sentAt)}</td>
                <td>${this.escapeHtml(batch.sentBy || '관리자')}</td>
                <td>${(() => {
                    // 회차의 mode — 한 회차는 단일 모드(baljoo|soojoo)로 발송됨. 첫 발송의 mode 사용.
                    // 수주(soojoo)만 명시, 그 외(baljoo·레거시 미기록)는 발주. (과거 발송은 전부 발주자)
                    const m = (batch.items[0] || {}).mode;
                    if (m === 'soojoo') return '<span class="hb-tpl-tag soojoo">수주자</span>';
                    return '<span class="hb-tpl-tag baljoo">발주자</span>';
                })()}</td>
                <td>${batch.items.length}명</td>
                <td>${totalOrders}건</td>
                <td class="hb-amt">${totalAmt.toLocaleString()}원</td>
                <td class="${resCls}">${result}</td>
            </tr>`;
        if (isExpanded) {
            const blocks = batch.filteredItems.map(h => self.renderHistPerson(batch, h)).join('');
            html += `<tr class="hist-detail-row"><td colspan="8" style="padding:0"><div class="hist-detail-box">${blocks}</div></td></tr>`;
        }
        return html;
    }
    renderHistPerson(batch, h) {
        const orders = h.orders || [];   // 발송 시점 스냅샷 (서버 공용 매핑 g5_sms_send_orders)
        const cnt = h.orderCount || 0;
        const amt = h.amount || 0;
        const pkey = batch.batchId + '|' + h.mb;
        const pExpanded = this.histPersonExpanded.has(pkey);
        const stCls = h.status === 'success' ? 'ok' : h.status === 'fail' ? 'fail' : 'pending';
        const stLabel = h.status === 'success' ? '성공' : h.status === 'fail' ? '실패' : '대기';
        let subHtml;
        if (orders.length) {
            // 수신자(=발주자 모드면 발주자 본인) 외에 표시할 '상대방' = 발주자 모드→수주자, 수주자 모드→발주자
            const isSoojooMode = h.mode === 'soojoo';
            const otherLabel   = isSoojooMode ? '발주자' : '수주자';
            const otherName    = r => isSoojooMode ? (r.balName || '') : (r.sooName || '');
            const otherTel     = r => isSoojooMode ? (r.balTel  || '') : (r.sooTel  || '');
            const rows = orders.map(r => `
                <tr>
                    <td class="d-onum">${r.onum}</td>
                    <td class="d-biz-cell"><span class="d-biz">${this.escapeHtml(r.biz)}</span></td>
                    <td class="d-date">${r.wdate}</td>
                    <td class="d-site">${this.escapeHtml(r.site)}</td>
                    <td class="d-amt">${r.amt.toLocaleString()}</td>
                    <td class="d-soo">${this.escapeHtml(otherName(r))}</td>
                    <td class="d-soo-tel">${this.escapeHtml(Util.phoneNumber(otherTel(r)))}</td>
                </tr>`).join('');
            subHtml = `<table class="ld-sub-table">
                <thead><tr>
                    <th style="width:72px">오더번호</th><th style="width:62px">업종</th><th style="width:52px">작업일</th>
                    <th style="padding-left:18px">현장주소</th><th style="width:80px">금액</th><th style="width:62px">${otherLabel}</th><th style="width:110px">연락처</th>
                </tr></thead><tbody>${rows}</tbody></table>`;
        } else {
            subHtml = `<div style="padding:10px 12px;color:#909090;font-size:13px">발송 당시 오더 상세가 저장되지 않은 건입니다 (이 기능 적용 전 발송분).</div>`;
        }
        return `
            <div class="ld-block">
                <div class="ld-person" data-pkey="${pkey}" onclick="WSM.toggleHistPerson('${pkey}', event)">
                    <span class="ld-chevron ${pExpanded ? 'open' : ''}">▶</span>
                    <span class="ld-nm">${this.escapeHtml(h.name)}</span>
                    <span class="ld-ph">${this.escapeHtml(Util.phoneNumber(h.tel || ''))}</span>
                    <span class="ld-cnt">${cnt}건</span>
                    <span class="ld-am">${amt.toLocaleString()}원</span>
                    <span class="ld-st ${stCls}">${stLabel}</span>
                    <span class="ld-type">${cnt > 1 ? '여러건' : '단건'}</span>
                    <button class="ld-resend" onclick="event.stopPropagation();WSM.resendHistoryById(${h.id})">재발송</button>
                </div>
                <div class="ld-sub ${pExpanded ? 'show' : ''}">${subHtml}</div>
            </div>`;
    }

    // 재발송 — 발송될 문자를 미리 보여주고 확인 후 발송
    resendHistoryById(id) {
        const h = this.sendHistory.find(x => x.id === id);
        if (!h) return;
        this.currentResendId = id;
        const statusLabel = h.status === 'success' ? '✓ 성공' : h.status === 'fail' ? '✗ 실패' : '⏳ 대기';
        $('#msgViewWho').text(h.name);
        $('#resendInfo').html(
            `<div class="ri-row"><span class="ri-l">발주자</span><span class="ri-v">${this.escapeHtml(h.name)} · ${this.escapeHtml(Util.phoneNumber(h.tel || ''))}</span></div>` +
            `<div class="ri-row"><span class="ri-l">이전 발송</span><span class="ri-v">${this.escapeHtml(h.sentAt)} (${statusLabel})</span></div>`
        );
        $('#msgViewBody').text(h.message || '-');
        $('#msgViewModal').addClass('show');
    }
    closeMsgView() { $('#msgViewModal').removeClass('show'); this.currentResendId = null; }
    doResend() {
        const self = this;
        const h = this.sendHistory.find(x => x.id === this.currentResendId);
        if (!h) return;
        $.ajax({
            url: '/adm/ajax/order/whan/send', type: 'post',
            data: { from_phone: this.selectedSender.number, targets: [{ mb_no: h.mbNo || 0, phone: h.tel, message: h.message }] },
            success(res) {
                if (res && res.ok) { self.closeMsgView(); self.toast(`🔄 ${h.name}님에게 재발송 요청했습니다.`, 'success'); self.openHistoryModal(); }
                else self.toast((res && res.message) || '재발송 실패', 'danger');
            },
            error() { self.toast('재발송 중 오류가 발생했습니다.', 'danger'); },
        });
    }

    // ==================== 일괄 발송 (큐 적재) ====================
    sendBulk() {
        const list = this.orderers;
        if (list.length === 0) { this.toast('대상자가 없습니다.', 'danger'); return; }
        if (!$('#msgBody').val().trim()) { this.toast('문자 내용을 입력하세요.', 'danger'); return; }
        const check = this.validateVars();
        const msg = (!check.valid && check.reason === 'invalid')
            ? `⚠ 알 수 없는 변수가 있습니다: ${check.invalid.map(v => '{' + v + '}').join(', ')}\n\n그대로 발송하시겠습니까?`
            : `${list.length}명에게 일괄 발송하시겠습니까?\n발송 후에는 취소할 수 없습니다.`;
        Util.swalert(msg, () => {
            // onums: 발송 직전 서버 재검증용 — 목록 조회 후 발송 사이에 환원/제외된 발주자는 서버가 걸러낸다.
            const targets = list.map(o => ({ mb_no: o.mbNo, phone: o.tel, message: this.renderPlain(o), onums: (o.orders || []).map(x => x.onum) }));
            $('#wsmRoot .sub-modal-bg').each(function () { if (this.id !== 'progressModal') this.classList.remove('show'); });
            this.startProgressSend(targets);
        }, ['발송', '취소']);
    }

    startProgressSend(targets) {
        const self = this;
        const total = targets.length;
        $('#progressModal').addClass('show');
        $('#progressCloseBtn').hide();
        $('#progressFooter').hide();
        $('#progressSummary').hide();
        $('#prgFill').removeClass('done').css('width', '0%');
        $('#prgPercent').text('0%');
        $('#prgCount').text(`0 / ${total}`);
        $('#prgTotal').text(total);
        $('#prgSuccess').text('0');
        $('#prgFail').text('0');
        $('#prgRemain').text(total);
        $('#progressStatus').text('발송 요청 중').attr('style', 'background:#FFF9D9;color:#79530C;border:1px solid #FDDE71');
        $('#progressLog').html('');

        $.ajax({
            url: '/adm/ajax/order/whan/send', type: 'post',
            // searchParams 동봉 → 서버 재검증이 목록(whanSmsList)과 동일한 필터를 재사용
            data: { from_phone: this.selectedSender.number, targets, ...(this.searchParams || {}) },
            success(res) {
                if (!res || !res.ok) { self.progressError((res && res.message) || '발송 요청 실패'); return; }
                const results = res.results || [];
                let idx = 0, success = 0, fail = 0;
                const startTime = Date.now();
                (function step() {
                    if (idx >= total) { self.finalizeProgress(success, fail, total, startTime); return; }
                    const t = targets[idx];
                    const r = results[idx] || { ok: true };
                    const ok = r.ok !== false;
                    self.appendProgressLog(ok, self.targetName(t), t.phone, r.reason || '');
                    if (ok) success++; else fail++;
                    idx++;
                    const pct = Math.round((idx / total) * 100);
                    $('#prgFill').css('width', pct + '%');
                    $('#prgPercent').text(pct + '%');
                    $('#prgCount').text(`${idx} / ${total}`);
                    $('#prgSuccess').text(success);
                    $('#prgFail').text(fail);
                    $('#prgRemain').text(total - idx);
                    setTimeout(step, 50);
                })();
            },
            error() { self.progressError('서버 오류로 발송 요청에 실패했습니다.'); },
        });
    }
    targetName(t) {
        const o = this.orderers.find(x => x.mbNo === t.mb_no);
        return o ? o.name : (t.phone || '');
    }
    appendProgressLog(isOk, name, phone, reason) {
        const log = document.getElementById('progressLog');
        const empty = log.querySelector('.prg-log-empty');
        if (empty) empty.remove();
        const time = new Date().toTimeString().slice(0, 8);
        const cls = isOk ? 'success' : 'fail';
        const mark = isOk ? '✓' : '✗';
        const tail = isOk ? '발송 요청 접수' : `요청 실패 <small>(${this.escapeHtml(reason)})</small>`;
        log.insertAdjacentHTML('beforeend', `
            <div class="prg-line ${cls}">
                <span class="prg-time">[${time}]</span>
                <span class="prg-mark">${mark}</span>
                <span class="prg-text">${this.escapeHtml(name)} (${this.escapeHtml(phone)}) — ${tail}</span>
            </div>`);
        log.scrollTop = log.scrollHeight;
    }
    finalizeProgress(success, fail, total, startTime) {
        const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);
        $('#prgFill').addClass('done');
        const $status = $('#progressStatus');
        if (fail === 0) $status.text('✓ 요청 완료').attr('style', 'background:#F0FDF4;color:#15803D;border:1px solid #22C55E');
        else $status.text(`완료 (${fail}건 실패)`).attr('style', 'background:#FFFBEB;color:#79530C;border:1px solid #FDCF43');
        const $summary = $('#progressSummary');
        $summary.css('display', 'flex').toggleClass('has-fail', fail > 0);
        $('#psTitle').text(fail === 0 ? '✓ 발송 요청이 완료되었습니다' : '⚠ 일부 발송 요청이 실패했습니다');
        $('#psDetail').text(`총 ${total}건 · 요청 ${success}건 · 실패 ${fail}건 · 소요 ${elapsed}초 · 실제 발송결과는 [발송 이력]에서 확인`);
        $summary.find('.ps-icon').text(fail === 0 ? '✓' : '!');
        $('#progressCloseBtn').css('display', 'flex');
        $('#progressFooter').css('display', 'flex');

        // 발송된 건이 있으면 대상자 목록을 다시 불러와 '발송됨' 배지 반영 + 자동선택에서 제외
        // → 진행모달을 닫으면 무엇을 보냈는지 발송 화면에서 바로 확인 가능
        if (success > 0) this.fetchList();
    }
    progressError(msg) {
        $('#progressStatus').text('실패').attr('style', 'background:#FFEFED;color:#FF382D;border:1px solid rgba(255,56,45,0.35)');
        const $summary = $('#progressSummary');
        $summary.css('display', 'flex').addClass('has-fail');
        $('#psTitle').text('⚠ 발송 요청에 실패했습니다');
        $('#psDetail').text(msg);
        $summary.find('.ps-icon').text('!');
        $('#progressCloseBtn').css('display', 'flex');
        $('#progressFooter').css('display', 'flex');
    }
    closeProgress() {
        // 진행모달만 닫고 발송 화면은 유지 — 갱신된 목록(발송됨 배지)으로 발송 결과 확인
        $('#progressModal').removeClass('show');
    }
    closeProgressOpenHistory() {
        $('#progressModal').removeClass('show');
        this.openHistoryModal();
    }

    // ==================== 발송번호 선택 ====================
    openSenderModal() {
        this.tempSelectedSender = this.selectedSender;
        this.renderSenderList();
        $('#senderModal').addClass('show');
    }
    closeSenderModal() { $('#senderModal').removeClass('show'); this.tempSelectedSender = null; }
    renderSenderList() {
        const self = this;
        $('#senderList').html(this.senderNumbers.map((s, i) => {
            const isSelected = self.tempSelectedSender && self.tempSelectedSender.number === s.number;
            return `
                <div class="sender-item ${isSelected ? 'selected' : ''} ${s.isDefault ? 'default-tag' : ''}" onclick="WSM.pickSender(${i})">
                    <div class="radio"></div>
                    <div class="si-main"><div class="si-number">${self.escapeHtml(Util.phoneNumber(s.number))}</div><div class="si-name">${self.escapeHtml(s.name)}</div></div>
                    ${s.isDefault ? `<span class="si-badge">기본</span>` : ''}
                </div>`;
        }).join(''));
        $('#senderApplyBtn').prop('disabled', !this.tempSelectedSender);
    }
    pickSender(i) { this.tempSelectedSender = this.senderNumbers[i]; this.renderSenderList(); }
    applySender() {
        if (!this.tempSelectedSender) return;
        this.selectedSender = this.tempSelectedSender;
        $('#senderNumber').text(Util.phoneNumber(this.selectedSender.number));
        $('#senderTag').text(this.selectedSender.name);
        this.closeSenderModal();
        this.toast(`📞 발송번호가 ${Util.phoneNumber(this.selectedSender.number)}로 변경되었습니다.`, 'success');
    }

    // ==================== 토스트 ====================
    toast(msg, type) {
        // 관리자 공용 토스트로 통일 (danger → error)
        $j.F.Admin.Util.adminToast((type === 'danger' || type === 'error') ? 'error' : 'success', msg);
    }

    escapeHtml(s) {
        const d = document.createElement('div');
        d.appendChild(document.createTextNode(s == null ? '' : String(s)));
        return d.innerHTML;
    }

    // ==================== 마크업 1회 주입 ====================
    ensureBuilt() {
        if (this.built) return;
        window.WSM = this; // 인라인 onclick 브리지
        const def = this.senderNumbers[0];
        const root = document.createElement('div');
        root.id = 'wsmRoot';
        root.innerHTML = this.modalHtml(def);
        document.body.appendChild(root);
        this.built = true;
    }

    modalHtml(def) {
        return `
<div class="bg-overlay" id="bgOverlay" style="display:none"></div>

<div class="modal-wrap" id="modalWrap" style="display:none">
  <div class="modal modal-wide">
    <div class="modal-header">
      <div class="title-area"><h1>환원예정건 문자발송</h1></div>
      <div class="header-actions">
        <div class="wsm-tabs">
          <button class="wsm-tab active" data-tab="send" onclick="WSM.switchTab('send')">✉️ 발송</button>
          <button class="wsm-tab" data-tab="history" onclick="WSM.openHistoryModal()">📋 발송이력</button>
        </div>
        <button class="close-btn" title="닫기" onclick="WSM.closeSendModal()">✕</button>
      </div>
    </div>

    <div class="wsm-tab-panel" id="tabPanelSend">
    <div class="split-body">
      <div class="split-left">
        <div class="panel-title panel-title-left">
          <span class="pt-num">1</span>
          <span class="pt-label">발송 대상자 선택</span>
          <span class="pt-sub">환원예정일 <strong id="wsmExpLabel">-</strong> · <strong id="wsmDday">-</strong></span>
        </div>
        <div class="left-filterbar">
          <select id="spBizFilter" onchange="WSM.onBizFilterChange()">
            <option value="">업종 전체</option>
            <option value="스카이">스카이</option>
            <option value="크레인">크레인</option>
            <option value="지게차">지게차</option>
            <option value="사다리">사다리</option>
            <option value="굴삭기">굴삭기</option>
            <option value="리프트">리프트</option>
          </select>
          <input type="text" id="spSearch" placeholder="이름/연락처" oninput="WSM.renderTargetList()" style="width:140px">
          <div class="wsm-mode-toggle">
            <button type="button" class="wsm-mode-btn active" data-mode="baljoo" onclick="WSM.setMode('baljoo')">발주자</button>
            <button type="button" class="wsm-mode-btn" data-mode="soojoo" onclick="WSM.setMode('soojoo')">수주자</button>
          </div>
        </div>
        <div class="left-summary">
          <button class="sp-check-all" id="spCheckAll" onclick="WSM.spToggleAll()"><span class="cb"></span> 전체 선택</button>
          <button class="sp-check-all sp-check-sent" id="spIncludeSent" onclick="WSM.spToggleSent()"><span class="cb"></span> 발송됨 포함</button>
          <span class="ls-stat">선택 <strong id="statTargets">0</strong>명 · <strong id="statOrders">0</strong>건</span>
          <span class="ls-stat ls-amt"><strong id="statAmount">0</strong>원</span>
        </div>
        <div class="target-list" id="targetList"></div>
      </div>

      <div class="split-right">
        <div class="panel-title panel-title-right">
          <span class="pt-num">2</span>
          <span class="pt-label">문자 내용 작성</span>
        </div>
        <div class="modal-body">
          <div class="section-label">
            <span class="sl-title">메시지 작성</span>
            <select id="templateSelect" class="template-select-inline" onchange="WSM.applyTemplate()">
              <option value="custom">[직접작성]</option>
            </select>
          </div>
          <div class="date-info-row">
            <span class="date-helper">📅 날짜를 지정하면 본문에 자동 반영됩니다</span>
            <label class="date-inline-label">환원예정일</label>
            <input type="date" id="expDate" class="date-inline-input" onchange="WSM.onExpDateChange()">
          </div>
          <div class="var-row">
            <div class="var-warning" id="varWarning"></div>
          </div>
          <div class="msg-textarea-wrap">
            <div class="msg-editor">
              <div class="msg-highlight" id="msgHighlight" aria-hidden="true"></div>
              <textarea id="msgBody" class="msg-textarea" spellcheck="false" oninput="WSM.updateMeta()" onscroll="WSM.syncHighlightScroll()" placeholder="문자 내용을 입력하세요."></textarea>
            </div>
            <div class="msg-meta">
              <span class="byte"><span id="byteCount">0</span> byte · <span id="lineCount">0</span>줄</span>
              <span>발송타입: <span id="msgType" class="type-tag sms">SMS</span>
              </span>ㅅ
            </div>
          </div>
          <div class="action-row">
            <button class="action-btn" onclick="WSM.openPreviewModal()">📱 미리보기</button>
            <button class="reset-text-btn" onclick="WSM.resetTemplate()">↩ 템플릿 초기화</button>
          </div>
        </div>
      </div>
    </div>

    <div class="send-zone">
      <div class="sender-row">
        <span class="sz-num">3</span>
        <span class="label">발송번호</span>
        <span class="number" id="senderNumber">${this.escapeHtml(Util.phoneNumber(def.number))}</span>
        <span class="number-tag" id="senderTag">${this.escapeHtml(def.name)}</span>
        <button class="change-btn" onclick="WSM.openSenderModal()">변경</button>
      </div>
      <div class="modal-footer">
        <div class="footer-info" id="footerInfo">발송할 대상자를 선택하세요</div>
        <div class="footer-actions">
          <button class="btn btn-sample-y" onclick="WSM.openSampleModal()">📤 샘플 발송</button>
          <button class="btn btn-cancel" onclick="WSM.closeSendModal()">취소</button>
          <button class="btn btn-send" onclick="WSM.sendBulk()" id="sendBtn" disabled>🚀 발송하기</button>
        </div>
      </div>
    </div>
    </div>

    <div class="wsm-tab-panel" id="tabPanelHistory" style="display:none">
      <div class="history-controls">
        <div class="hist-filter-row">
          <label class="hist-filter-label">발송일시</label>
          <div class="hist-pills">
            <button class="hist-pill active" data-hp="tm" onclick="WSM.setHistPeriod('tm', this)">이달</button>
            <button class="hist-pill" data-hp="lm" onclick="WSM.setHistPeriod('lm', this)">전달</button>
            <button class="hist-pill" data-hp="c" onclick="WSM.setHistPeriod('c', this)">날짜지정</button>
          </div>
          <input type="date" class="hist-date" id="histDateFrom" onchange="WSM.onHistDateInput()">
          <span style="color:#AFAFAF">~</span>
          <input type="date" class="hist-date" id="histDateTo" onchange="WSM.onHistDateInput()">
        </div>
        <div class="hist-filter-row">
          <label class="hist-filter-label">발송결과</label>
          <div class="hist-pills" id="histStatusPills">
            <button class="hist-pill active" data-st="" onclick="WSM.setHistoryFilter('', this)">전체</button>
            <button class="hist-pill" data-st="ok" onclick="WSM.setHistoryFilter('ok', this)">성공</button>
            <button class="hist-pill" data-st="part" onclick="WSM.setHistoryFilter('part', this)">일부성공</button>
            <button class="hist-pill" data-st="fail" onclick="WSM.setHistoryFilter('fail', this)">실패</button>
            <button class="hist-pill" data-st="pending" onclick="WSM.setHistoryFilter('pending', this)">대기</button>
          </div>
        </div>
        <div class="hist-filter-row">
          <label class="hist-filter-label">대상</label>
          <div class="hist-pills" id="histModePills">
            <button class="hist-pill active" data-hm="" onclick="WSM.setHistoryMode('', this)">전체</button>
            <button class="hist-pill" data-hm="baljoo" onclick="WSM.setHistoryMode('baljoo', this)">발주자</button>
            <button class="hist-pill" data-hm="soojoo" onclick="WSM.setHistoryMode('soojoo', this)">수주자</button>
          </div>
        </div>
        <div class="hist-filter-row">
          <label class="hist-filter-label">검색</label>
          <input type="text" id="histSearch" class="hist-search-input" placeholder="수신자 이름, 연락처 검색" oninput="WSM.renderHistory()">
        </div>
      </div>
      <div class="hist-table-wrap">
        <table class="hist-table">
          <colgroup>
            <col style="width:64px"><col style="width:140px"><col style="width:80px">
            <col style="width:90px"><col style="width:54px"><col style="width:54px">
            <col style="width:110px"><col style="width:76px">
          </colgroup>
          <thead>
            <tr>
              <th></th><th>발송일시</th><th>발송자</th><th>템플릿</th>
              <th>대상</th><th>건수</th><th style="text-align:right">합계금액</th><th>결과</th>
            </tr>
          </thead>
          <tbody id="historyList"></tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="sub-modal-bg" id="previewModal">
  <div class="sub-modal">
    <div class="sub-modal-header">
      <h2>📱 발송 미리보기 <span class="pill" id="previewModalCount">0건</span></h2>
      <button class="close-btn" onclick="WSM.closePreviewModal()">✕</button>
    </div>
    <div class="sub-modal-body">
      <div class="preview-controls">
        <div class="nav">
          <button onclick="WSM.prevPreview()" id="prevBtn">◀</button>
          <span class="indicator"><strong id="previewIdx">0</strong> / <span id="previewTotal">0</span></span>
          <button onclick="WSM.nextPreview()" id="nextBtn">▶</button>
        </div>
        <div class="target" id="previewTarget">-</div>
      </div>
      <div class="preview-phone"><div class="preview-bubble" id="previewBubble">대상자가 없습니다.</div></div>
    </div>
    <div class="sub-modal-footer"><button class="btn btn-cancel" onclick="WSM.closePreviewModal()">닫기</button></div>
  </div>
</div>

<div class="sub-modal-bg" id="sampleModal">
  <div class="sub-modal">
    <div class="sub-modal-header">
      <h2>📤 샘플 발송 <span class="pill">테스트</span></h2>
      <button class="close-btn" onclick="WSM.closeSampleModal()">✕</button>
    </div>
    <div class="sub-modal-body">
      <div class="field">
        <label>📞 받는 번호 (테스트)</label>
        <input type="tel" id="sampleTel" placeholder="010-0000-0000" onkeydown="if(event.key==='Enter')WSM.sendSample()">
        <p class="helper warn">⚠ 입력한 번호로 1건 발송됩니다. 발송이력엔 저장되지 않습니다.</p>
      </div>
    </div>
    <div class="sub-modal-footer">
      <button class="btn btn-cancel" onclick="WSM.closeSampleModal()">취소</button>
      <button class="btn btn-send" onclick="WSM.sendSample()">샘플 발송</button>
    </div>
  </div>
</div>

<div class="sub-modal-bg" id="msgViewModal">
  <div class="sub-modal" style="width:440px">
    <div class="sub-modal-header">
      <h2>🔄 재발송 <span class="pill" id="msgViewWho">-</span></h2>
      <button class="close-btn" onclick="WSM.closeMsgView()">✕</button>
    </div>
    <div class="sub-modal-body">
      <div class="resend-info" id="resendInfo"></div>
      <div style="font-size:13px;color:#626262;font-weight:600;margin:4px 0 8px">아래 내용으로 다시 발송됩니다.</div>
      <div class="hist-phone"><div class="hist-bubble" id="msgViewBody">-</div></div>
    </div>
    <div class="sub-modal-footer">
      <button class="btn btn-cancel" onclick="WSM.closeMsgView()">취소</button>
      <button class="btn btn-send" onclick="WSM.doResend()">🔄 재발송</button>
    </div>
  </div>
</div>

<div class="sub-modal-bg" id="progressModal">
  <div class="sub-modal">
    <div class="sub-modal-header">
      <h2>🚀 일괄 발송 요청 <span class="pill" id="progressStatus">발송 요청 중</span></h2>
      <button class="close-btn" onclick="WSM.closeProgress()" id="progressCloseBtn" style="display:none">✕</button>
    </div>
    <div class="sub-modal-body">
      <div class="progress-stats">
        <div class="progress-stat"><div class="label">전체</div><div class="value" id="prgTotal">0</div></div>
        <div class="progress-stat success"><div class="label">요청</div><div class="value" id="prgSuccess">0</div></div>
        <div class="progress-stat fail"><div class="label">실패</div><div class="value" id="prgFail">0</div></div>
        <div class="progress-stat"><div class="label">남음</div><div class="value" id="prgRemain">0</div></div>
      </div>
      <div class="progress-bar-wrap">
        <div class="progress-bar-track"><div class="progress-bar-fill" id="prgFill" style="width:0%"></div></div>
        <div class="progress-bar-text"><span id="prgPercent" class="prg-percent">0%</span><span id="prgCount">0 / 0</span></div>
      </div>
      <div class="progress-log" id="progressLog"><div class="prg-log-empty">발송 준비 중...</div></div>
      <div class="progress-summary" id="progressSummary" style="display:none">
        <div class="ps-icon">✓</div>
        <div class="ps-text"><strong id="psTitle">발송 요청 완료</strong><span id="psDetail">-</span></div>
      </div>
    </div>
    <div class="sub-modal-footer" id="progressFooter" style="display:none">
      <button class="btn btn-cancel" onclick="WSM.closeProgress()">닫기</button>
      <button class="btn btn-sample" onclick="WSM.closeProgressOpenHistory()">📋 발송 이력 보기</button>
    </div>
  </div>
</div>

<div class="sub-modal-bg" id="senderModal">
  <div class="sub-modal" style="width:480px">
    <div class="sub-modal-header">
      <h2>📞 발송번호 선택</h2>
      <button class="close-btn" onclick="WSM.closeSenderModal()">✕</button>
    </div>
    <div class="sub-modal-body">
      <p class="helper" style="margin-bottom:12px;color:#626262">사전 등록된 발신번호 중에서 선택하세요.<br>발신번호는 g5_config 의 sms_sender_phones 에서 관리됩니다.</p>
      <div class="sender-list" id="senderList"></div>
    </div>
    <div class="sub-modal-footer">
      <button class="btn btn-cancel" onclick="WSM.closeSenderModal()">취소</button>
      <button class="btn btn-send" onclick="WSM.applySender()" id="senderApplyBtn" disabled>선택</button>
    </div>
  </div>
</div>`;
    }
}